import { ofType } from 'redux-observable';
import { concat } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import { verifyABTest } from '@perpay-web/fintech/actions/shared/abTests';
import { fetchAccountSummary } from '@perpay-web/fintech/actions/shared/accountSummary';
import { primaryJob, salaryInfo } from '@perpay-web/fintech/actions/ui/signup';
import { PINWHEEL_SPLIT_STEP } from '@perpay-web/fintech/components/composite/PaymentSetup/PaymentSetupSteps';
import {
    PINWHEEL_SPLIT_CREATE_PRIMARY_JOB,
    PINWHEEL_SPLIT_UPDATE_SALARY_INFO,
    STORE_REPLACE_JOBS,
    STORE_REPLACE_SALARY_INFO,
} from '@perpay-web/fintech/constants/actionTypes';
import { waitForAbTestAndSetPaymentSetupStep as waitForAbTestEpic } from '@perpay-web/fintech/epics/ui/paymentSetup';
import { dispatchObservable } from '@perpay-web/observable/dispatchObservable';

export const waitForAbTestAndSetPaymentSetupStep =
    waitForAbTestEpic(PINWHEEL_SPLIT_STEP);

export function pinwheelSplitUpdateSalaryInfo(action$, state$) {
    return action$.pipe(
        ofType(PINWHEEL_SPLIT_UPDATE_SALARY_INFO),
        mergeMap((action) => {
            const { payload } = action;
            return concat(
                dispatchObservable({
                    action$,
                    state$,
                    initialDispatch: [salaryInfo(payload)],
                    waitFor: [STORE_REPLACE_SALARY_INFO],
                    waitForDispatch: () => [
                        verifyABTest('pinwheel'),
                        fetchAccountSummary(),
                    ],
                }),
                waitForAbTestAndSetPaymentSetupStep(action$, state$),
            );
        }),
    );
}

export function pinwheelSplitCreatePrimaryJob(action$, state$) {
    return action$.pipe(
        ofType(PINWHEEL_SPLIT_CREATE_PRIMARY_JOB),
        mergeMap((action) => {
            const { payload } = action;

            return concat(
                dispatchObservable({
                    action$,
                    state$,
                    initialDispatch: [primaryJob(payload)],
                    waitFor: [STORE_REPLACE_JOBS],
                    waitForDispatch: () => [
                        verifyABTest('pinwheel'),
                        fetchAccountSummary(),
                    ],
                }),
                waitForAbTestAndSetPaymentSetupStep(action$, state$),
            );
        }),
    );
}
